import { Grid, GridProps } from "@mui/material";
import React from "react";

interface MxCPropertyContentDetailLargeProps extends GridProps {
  children: any;
}
const MxCPropertyContentDetailLarge = (
  props: MxCPropertyContentDetailLargeProps
) => {
  return <Grid container item xs={12} py={1} px={2} rowGap={0.5} {...props} />;
};

export default MxCPropertyContentDetailLarge;
